import { getUserEntities } from "@api/user.api";

export async function fetchEntitiesAccounts(workspaceId: string | null) {
    return workspaceId ? await getUserEntities(workspaceId) : undefined;
}
